// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZKLD4eNoLuUefo9I{background-color:var(--py-neutral-0);border-radius:8px}.ZKLD4eNoLuUefo9I.bSdnm3odlX409hYx{border:1px solid var(--py-neutral-4)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `ZKLD4eNoLuUefo9I`,
	"bordered": `bSdnm3odlX409hYx`
};
export default ___CSS_LOADER_EXPORT___;
